import React from "react";
import {
  CBadge,
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CProgress,
  CNavLink,
} from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import {
  cilBasket,
  cilBell,
  cilChartPie,
  cilSpeedometer,
  cilUserFollow,
  cilUserUnfollow,
  cilCalendar,
  cilAvTimer,
  cilCalendarCheck,
} from "@coreui/icons";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import Appconfig from "../../APPconfig";
const AppHeaderDropdownNotif = () => {
  var compid = localStorage.getItem("compid");
  var empid = localStorage.getItem("empid");
  var loadnot = localStorage.getItem("LoadNot");
  const [itemsCount, setitemsCount] = useState(0);
  const [NotList, setNotList] = useState([]);
  const [load,setload] = useState(true);
  if(load){
    notification();
    setload(false);
  }
  
  // useEffect(() => {
  //   var timerID = setInterval(async function() {
  //     notification();
  //  // };
  // }, 120 * 1000);
  // clearInterval(timerID);
  // }, []);

async function notification() {
  const url = Appconfig.URL + "/notifications/getlistcount";
  //const fetchData = async () => {
  try {
    const response = await fetch(url, {
      headers: {
        compid: compid,
        empentry: empid,
      },
    });
    const json = await response.json();
    setNotList(json);
    //localStorage.setItem("Notjson", json); 
    var j = 0;
    for (var i = 0; i < json.length; i++) {
      j = j + json[i].Count;
    }
    setitemsCount(j);
    //localStorage.setItem("NotCount", j);
  } catch (error) {
    console.log("error", error);
  }
}
//var NotCount = localStorage.getItem("NotCount");
  return (
    <CDropdown variant="nav-item" id="headnavitem" alignment="end"onClick={notification}  >
      <CDropdownToggle caret={false} >
        <CIcon icon={cilBell} size="lg" className="my-1 mx-2" />
        <CBadge
          shape="rounded-pill"
          color="danger-gradient"
          className="position-absolute top-0 end-0"
          style={{ display: itemsCount == 0 ? "none" : "inline-block" }}
        >
          {itemsCount}
        </CBadge>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10">
          <strong>You have {itemsCount} notifications</strong>
        </CDropdownHeader>
        {/* <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10">
          <strong>Approval</strong>
        </CDropdownHeader> */}
        {NotList.map((item) => (
          <CDropdownItem>
            <CNavLink to={item.Nav} component={NavLink} size="sm">
              {/* <CIcon icon={cilCalendarCheck} className="me-2 text-success" /> */}
              {item.Type}
              <CBadge color={item.Color}>{item.Count}</CBadge>
            </CNavLink>
          </CDropdownItem>
        ))}
        {/* <CDropdownItem>
          <CIcon icon={cilChartPie} className="me-2 text-danger"  /> Leave Request
        </CDropdownItem>
        <CDropdownItem>
          <CIcon icon={cilCalendarCheck} className="me-2 text-info" /> Compensatory Off Request
        </CDropdownItem>
        <CDropdownItem>
          <CIcon icon={cilAvTimer} className="me-2 text-primary" /> OT Request
        </CDropdownItem> */}
        {/* <CDropdownItem>
          <CIcon icon={cilSpeedometer} className="me-2 text-warning" /> Server overloaded
        </CDropdownItem> */}
        {/* <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10">
          <strong>Server</strong>
        </CDropdownHeader>
        <CDropdownItem className="d-block">
          <div className="text-uppercase mb-1">
            <small>
              <b>CPU Usage</b>
            </small>
          </div>
          <CProgress thin color="info-gradient" value={25} />
          <small className="text-medium-emphasis">348 Processes. 1/4 Cores.</small>
        </CDropdownItem>
        <CDropdownItem className="d-block">
          <div className="text-uppercase mb-1">
            <small>
              <b>Memory Usage</b>
            </small>
          </div>
          <CProgress thin color="warning-gradient" value={70} />
          <small className="text-medium-emphasis">11444GB/16384MB</small>
        </CDropdownItem>
        <CDropdownItem className="d-block">
          <div className="text-uppercase mb-1">
            <small>
              <b>SSD 1 Usage</b>
            </small>
          </div>
          <CProgress thin color="danger-gradient" value={90} />
          <small className="text-medium-emphasis">243GB/256GB</small>
        </CDropdownItem> */}
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdownNotif;
